/**
* Pushes a parsed object to the Google Tag Manager dataLayer.
* @param dataLayerStr A JSON string representing the data to push to the dataLayer.
*/
export const dataLayerPush = (dataLayerStr?: string) => {
    if (!!dataLayerStr) {
        window.dataLayer = window.dataLayer || [];

        try {
            window.dataLayer.push(JSON.parse(dataLayerStr));
        } catch (error) {
            console.error('[dataLayerPush] Invalid JSON string:', error);
        }
    }
};